import React from 'react';
import { useQuery } from '@apollo/client';
import { SEARCH_POSTS } from '../graphql/queries';
import { Link, useLocation } from 'react-router-dom';
import PageHeader from './global-components/page-header';

const SearchResults = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get('q') || '';
    const publicUrl = process.env.PUBLIC_URL + '/';

    const { data, loading, error } = useQuery(SEARCH_POSTS, {
        variables: { search: searchQuery, first: 20 },
        skip: !searchQuery
    });

    const posts = data?.posts?.nodes || [];

    // Helper function to format date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    };

    // Helper function to get excerpt
    const getExcerpt = (excerpt, maxLength = 150) => {
        if (!excerpt) return '';
        const text = excerpt.replace(/<[^>]*>/g, '');
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    // Helper function to get featured image URL
    const getFeaturedImage = (post) => {
        return post?.featuredImage?.node?.sourceUrl || publicUrl + 'assets/img/600x600bb-14.jpg';
    };

    // Helper function to get first category
    const getFirstCategory = (post) => {
        return post?.categories?.nodes?.[0] || { name: 'Uncategorized', slug: 'uncategorized' };
    };

    return (
        <div>
            <PageHeader headertitle={`Search Results for: "${searchQuery}"`} />

            <div className="blog-page-area pd-bottom-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {!searchQuery && (
                                <div className="text-center py-5">
                                    <h4>Please enter a search term</h4>
                                </div>
                            )}

                            {loading && (
                                <div className="text-center py-5">
                                    <p>Searching...</p>
                                </div>
                            )}

                            {error && (
                                <div className="text-center py-5">
                                    <p>Error loading search results. Please try again.</p>
                                </div>
                            )}

                            {!loading && !error && searchQuery && posts.length === 0 && (
                                <div className="text-center py-5">
                                    <h4>No results found for "{searchQuery}"</h4>
                                    <p>Try different keywords or browse our categories.</p>
                                </div>
                            )}

                            {!loading && !error && posts.length > 0 && (
                                <div>
                                    <div className="mb-4">
                                        <h5>Found {posts.length} result{posts.length !== 1 ? 's' : ''}</h5>
                                    </div>
                                    <div className="row">
                                        {posts.map((post) => {
                                            const category = getFirstCategory(post);
                                            return (
                                                <div className="col-lg-6 col-md-6" key={post.id}>
                                                    <div className="single-blog-post style-two mb-4">
                                                        <div className="thumb">
                                                            <img
                                                                src={getFeaturedImage(post)}
                                                                alt={post?.featuredImage?.node?.altText || post.title}
                                                            />
                                                            <Link
                                                                className="tag-base tag-blue"
                                                                to={`/category/${category.slug}`}
                                                            >
                                                                {category.name}
                                                            </Link>
                                                        </div>
                                                        <div className="single-blog-details">
                                                            <p className="date">
                                                                <i className="fa fa-clock-o" /> {formatDate(post.date)}
                                                            </p>
                                                            <h5>
                                                                <Link
                                                                    to={`/blog/${post.slug}`}
                                                                    dangerouslySetInnerHTML={{ __html: post.title }}
                                                                />
                                                            </h5>
                                                            <p>{getExcerpt(post.excerpt)}</p>
                                                            <Link
                                                                className="btn btn-blue"
                                                                to={`/blog/${post.slug}`}
                                                            >
                                                                Read More <i className="fa fa-angle-right" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchResults;
